// 会计
const accounting = () => import('../pages/accounting/accounting.vue');
export default [
  {
    path: '/accounting',
    component: accounting,
  },
];
